/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the DateRange interface.
 */
export function instanceOfDateRange(value) {
    var isInstance = true;
    return isInstance;
}
export function DateRangeFromJSON(json) {
    return DateRangeFromJSONTyped(json, false);
}
export function DateRangeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'start': !exists(json, 'start') ? undefined : json['start'],
        'end': !exists(json, 'end') ? undefined : json['end'],
        'timeZone': !exists(json, 'timeZone') ? undefined : json['timeZone']
    };
}
export function DateRangeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'start': value.start,
        'end': value.end,
        'timeZone': value.timeZone
    };
}
